import { DiscountHeaderProps } from "src/components/styled/DiscountHeader"
import { formatPriceShort } from "src/utilities/price"

export type TileDiscountHeaderProps = DiscountHeaderProps

export const TileDiscountHeader = ({ discount, coupon, available }: TileDiscountHeaderProps) => {
  if (!available) {
    return <div className="grid grid-cols-1 justify-items-center p-2 text-center text-sm">🚫 Nicht verfügbar</div>
  }

  if (!discount) {
    return null
  }

  const heading = coupon ? "Aktion" : "Reduziert"
  const amount = coupon ? coupon.text : formatPriceShort(discount)

  return (
    <div className="text-np-red grid grid-cols-1 justify-items-center py-2 text-center text-sm font-bold">
      <div className="uppercase">{heading}:</div>
      <div>Spare {amount}</div>
    </div>
  )
}
